<template>
  <div v-if="!isLoading">
    <template v-if="valuations && valuations?.length > 0">
      <v-expansion-panels
        v-model="panel"
        variant="accordion"
        flat
        rounded="15"
      >
        <ValuationResultItem
          v-for="(valuation, index) in valuations"
          :key="valuation.id"
          :valuation="valuation"
          :index="index"
          :panel="panel"
          :open-id="openId"
          :is-master-view="isMasterView"
          :class="'mb-2' + (valuation.deleted ? ' deleted' : '')"
          @expand="updateOpenId"
          @deleted="onDelete"
        />
      </v-expansion-panels>
      <div
        v-if="hasMore"
        class="justify-center mt-4 d-flex"
      >
        <v-btn
          color="primary"
          @click="loadMore"
        >
          {{ $t('buttons.valuation.load-more-reviews') }}
        </v-btn>
      </div>
    </template>
    <v-alert
      v-else
      type="info"
    >
      <span>{{ $t('alerts.valuation.no-valuations') }}</span>
    </v-alert>
  </div>
</template>

<script>
import currencyMixin from '@/mixins/currency'

import GET_VALUATIONS_PAGINATED from './queries/getValuationsPaginated.gql'
import ValuationResultItem from './ValuationResultItem.vue'

const CHUNK_SIZE = 20

export default {
  components: {
    ValuationResultItem,
  },
  mixins: [currencyMixin],
  props: {
    currentValuation: {
      type: Object,
      default: null,
    },
    isMasterView: {
      type: Boolean,
      default: false,
    },
    routeParamId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      hasMore: false,
      valuations: [],
      panel: -1,
      page: 1,
      openId: '',
    }
  },
  watch: {
    currentValuation() {
      if (this.currentValuation && this.currentValuation.results) {
        if (this.valuations.find((obj) => obj.id === this.currentValuation.id)) return
        this.valuations.unshift(this.currentValuation)
        this.panel = this.valuations.length - 1
        this.openId = this.valuations ? this.valuations[0].id : ''
      }
    },
  },
  apollo: {
    getValuationsPaginated: {
      query: GET_VALUATIONS_PAGINATED,
      fetchPolicy: 'no-cache',
      loadingKey: 'isLoading',
      variables() {
        return {
          input: {
            page: this.page,
            itemsPerPage: CHUNK_SIZE,
            createdByAgent: true,
            isMasterView: this.isMasterView,
            childCompanyId: this.routeParamId,
          },
        }
      },
      skip() {
        return this.$auth.loading || !this.$auth.isAuthenticated
      },
      result({ data }) {
        if (!data || !data.getValuationsPaginated) return
        if (
          !data.getValuationsPaginated?.valuations ||
          data.getValuationsPaginated?.valuations?.length === 0
        ) {
          this.hasMore = false
          this.valuations = []
        }
        this.hasMore = data.getValuationsPaginated?.hasMore
        this.valuations.push(...data.getValuationsPaginated.valuations)
        this.$nextTick(() => {
          this.panel = 0
          this.openId = this.valuations.length > 1 ? this.valuations[0]?.id : ''
        })
      },
    },
  },
  methods: {
    onDelete(id) {
      this.valuations = this.valuations.map((valuation) => {
        if (valuation.id === id) {
          valuation.deleted = true
        }
        return valuation
      })
      setTimeout(() => {
        this.valuations = this.valuations.filter((valuation) => valuation.id !== id)
      }, 1000)
    },
    loadMore() {
      this.page += 1
    },
    updateOpenId(id) {
      this.openId = id
    },
  },
}
</script>

<style scoped>
.deleted {
  opacity: 0;
  transition: opacity 1s;
}
:deep(.v-expansion-panels--variant-accordion > :first-child:not(:last-child)) {
  border-bottom-left-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}

:deep(.v-expansion-panels--variant-accordion > :last-child:not(:first-child)) {
  border-top-left-radius: 15px !important;
  border-top-right-radius: 15px !important;
}
:deep(.v-expansion-panels--variant-accordion > :not(:first-child):not(:last-child)) {
  border-radius: 15px !important;
}
</style>
